import React from "react";
import FilePicker from "components/FilePicker";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { FileDownloadRounded, FileUploadRounded } from "@mui/icons-material";
import PropTypes from "prop-types";

function ImportList({ setIsLoading, selectedFile, setSelectedFile }) {
  const onSelect = async (uploadedFile) => {
    const file = Array.isArray(uploadedFile) && !uploadedFile.length ? null : uploadedFile;
    setSelectedFile(file);
  };

  const handleDownloadCSV = () => {
    const downloadUrl = `${process.env.REACT_APP_ASSETS_URL}example_bulk_upload.csv`;
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = "example_bulk_upload.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <MDBox p={1} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <MDButton sx={{ minWidth: "230px" }} color="gray80" onClick={handleDownloadCSV}>
        <FileDownloadRounded sx={{ marginRight: 2 }} /> Download sample CSV
      </MDButton>
      <MDBox>
        <FilePicker
          onSelect={onSelect}
          label={
            <>
              <FileUploadRounded sx={{ marginRight: 2 }} /> Upload CSV
            </>
          }
          allowedTypes={["text/csv"]}
          sizeLimit={25 * 1024 * 1024} // 25mb file size
          setIsLoading={setIsLoading}
          boxStyle={{ display: "flex", flexDirection: "column", alignItems: "center" }}
          buttonStyle={{ minWidth: "230px" }}
          initialFiles={
            // eslint-disable-next-line no-nested-ternary
            Array.isArray(selectedFile) ? selectedFile : selectedFile ? [selectedFile] : []
          }
        />
      </MDBox>
    </MDBox>
  );
}

export default ImportList;

ImportList.defaultProps = {
  selectedFile: "",
  setIsLoading: () => {},
  setSelectedFile: () => {},
};

ImportList.propTypes = {
  setIsLoading: PropTypes.func,
  selectedFile: PropTypes.string,
  setSelectedFile: PropTypes.func,
};
